import * as React from 'react';

import theme from '@travelnest/merlin.theme';
import { BlueLinkButton, HelpFeaturedContainer } from './components';
import { LOGIN_ROUTES } from './constants';

export interface ILoginCheckInboxProps {
	email: string;
}

export const LoginCheckInbox: React.FC<ILoginCheckInboxProps> = ({ email }) => {

	return <HelpFeaturedContainer>
		<h1>Log in to your Travelnest account</h1>
		<div>
			<p>We've sent a login link to <span className="login-check-inbox__email">{email}</span></p>
			<p>To login to your account, simply open the email we've sent you and click the Login button.</p>
		</div>
		<div style={{ marginTop: theme.layout.spacing.large }}>
			<BlueLinkButton
				id="email-help-btn"
				to={LOGIN_ROUTES.EMAIL_HELP}
			>Can't see the email?</BlueLinkButton>
		</div>
	</HelpFeaturedContainer>;
};
